<template>
  <div :class="{expanded: expanded}" >
    <popper
      ref="esSelect"
      trigger="click"
      :options="{
        placement: 'bottom',
        priority: 'bottom',
        modifiers: { offset: { offset: '-100px,0' } }
      }">
      <div class="popper">
        <div v-if="hasExpanded">
          <ul class="menu is-flex flex-direction--column">
            <es-menu-row
              v-for="(action, index) in setValues" :key="action.id"
              :action="action"
              :index="index"
              @callMenuAction="callMenuAction"
              ref="firstRowRef"
            />
          </ul>
        </div>
      </div>
      <div class="ellipsis" slot="reference" @click="toggle">
        <font-awesome-icon
          class="fa-3x has-text-primary"
          :icon="['fal', 'ellipsis-v']"
          tabindex="0"
          role="button"
          title="Actions Menu"
          @keypress.enter.prevent="togglePopper"
          ref="ellipsisRef"
        />
      </div>
    </popper>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEllipsisV,
} from '@fortawesome/pro-light-svg-icons';
import popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';
import EsMenuRow from '@/components/EsMenuRow.vue';

library.add(
  faEllipsisV,
);

export default {
  emits: ['callMenuAction'],
  props: {
    /**
     * A pre-defined list of items in the dropdown.
     */
    setValues: Array,
  },
  components: {
    EsMenuRow,
    popper,
  },
  data() {
    return {
      expanded: false,
      hasExpanded: false,
    };
  },
  methods: {
    callMenuAction(result) {
      if (result) {
        this.$emit('callMenuAction', { doAction: result.doAction });
      } else {
        this.$emit('callMenuAction');
      }
      this.toggle();
    },
    toggle() {
      this.expanded = !this.expanded;
      if (!this.hasExpanded) {
        this.hasExpanded = true;
      }
    },
    togglePopper() {
      this.toggle();
      this.$refs.esSelect.showPopper = !this.$refs.esSelect.showPopper;
      if (this.$refs.esSelect.showPopper) {
        this.$nextTick(() => {
          if (this.$refs.firstRowRef) {
            this.$refs.firstRowRef[0].$el.focus();
          }
        });
      } else if (!this.$refs.esSelect.showPopper) {
        this.$refs.ellipsisRef.focus();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "@/sass/custom.sass"
  .select.expanded
    &::after
      transform: rotate(135deg) !important
      -webkit-transform: rotate(135deg) !important
      margin-top: -0.1em !important
  .popper
    background-color: #fff !important
    border: 1px solid $primary
    border-top: 3px solid $primary
    border-radius: 0
    -webkit-box-shadow: none !important
    box-shadow: 0 4px 9px -4px #555 !important
    max-width: 200px !important
    padding: 8px 0px !important
    text-align: left
    padding: 0 !important
    .popper__arrow
      top: 0px
  .menu
    margin: 0
</style>
